import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { WindowToken } from '@degreed/lxp/services';
import { AuthService } from '@degreed/lxp/services/authorization';

// TODO: Delete this
// Once we are confident permissions are being handled correctly by the API we can remove this
@Injectable({
  providedIn: 'root',
})
export class SkillStandardsGuardService {
  constructor(
    private authService: AuthService,
    @Inject(WindowToken) private windowRef: Window,
    private router: Router
  ) {}
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    return true;
  }
}
